import { formatPrice } from "helpers";
import Barcode from "react-barcode";
import { useCallback, useRef, useState } from "react";
import useCurrency from "helpers/useCurrency";
import ReactToPrint from "react-to-print";
import Portal from "components/Portal";
import { Modal } from "@mui/material";
import ModalBox from "components/Shared/Modals/ModalBox";
import BasicButton from "components/BasicInputs/BasicButton";
import PrintImg from "assets/images/Print.svg";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { store, useAppDispatch, useAppSelector } from "store/store";
import { appSetLabelSettings } from "store/actions/appAction";
import axios from "../../../axios/axios";

export default function useLabelPrint(props?: { products?: Partial<Product>[] }) {
  const { getState, dispatch } = store
  const stores = useAppSelector((state: any) => state);
  const business = stores.businessReducer.business?.business;
  const appSettings = stores.appReducer?.appSettings || {};
  const labelSettings = stores.appReducer.labelSettings;
  const Token = getState().businessReducer.business?.token;
  const {
    labelPrintDisplayAddress,
    labelPrintDisplayBarcodeText,
    labelPrintDisplayPrice,
    labelPrintDisplayProductName,
    labelPrintDisplayBusinessName,
    labelPrintDisplayDescription,
    labelPrintDescription,

  } = appSettings;
  const labelPrintSetting = JSON.parse(appSettings.labelPrintSetting||null)
  const ref = useRef<any>(null);
  const contentRef = useRef<any>(null);
  const { defCur } = useCurrency();
  const [state, setState] = useState({
    open: false,
    item: undefined,
  });
  const [products, setProducts] = useState<Partial<Product>[] | undefined>(props?.products);
  // products/printLabelSetting
  //labelPrintSetting
  const defaultSettings = {
    count: 4,
    countInRow: 2,
    padding: 2,
    spacing: 2,
    width: 200,
    itemWidth: 90,
    itemHeight: 100,
    fonSmallness: 0,
  };
  const inputs = {
    width: "عرض کاغذ",
    padding: "حاشیه کاغذ",
    itemWidth: "عرض لیبل",
    itemHeight: "ارتفاع لیبل",
    spacing: "فاصله بین لیبل ها",
    fonSmallness: "ضریب فونت",
    count: "تعداد",
    countInRow: "تعداد در هر ردیف",
  };
  type LabelSettingsType = typeof defaultSettings;

  function Label({ product, settings }: { product: any; settings: any }) {
    let fSize = [10, 16, 32];
    let titleSize = 16
    if (settings.fonSmallness) titleSize = titleSize + settings.fonSmallness;
    return (
      <div
        className="flex flex-col items-center text-black"
        style={{ direction: "rtl", width: settings.itemWidth, height: settings.itemHeight }}
      >
        {labelPrintDisplayBusinessName && (
          <div className={`mb-1 flex justify-center text-center`} style={{ fontSize: fSize[0] }}>
            {business.nickName}
          </div>
        )}
        {labelPrintDisplayBarcodeText && (
          <div
            className={`w-full flex justify-center`}
            style={{ borderRight: "1px solid black", borderLeft: "1px solid black", fontSize: fSize[0] }}
          >
            {product.barcode}
          </div>
        )}
        <div className="flex justify-center w-full mb-1 [&>svg]:h-5">
          <Barcode
            value={product.barcode}
            displayValue={false}
            height={32}
            width={contentRef.current?.innerWidth}
            margin={0}
          />
        </div>
        {labelPrintDisplayProductName && (
          <div className={` font-semibold text-center`} style={{ fontSize: titleSize }}>
            {product.title}
          </div>
        )}
        {labelPrintDisplayDescription && (
          <div style={{ fontSize: fSize[0] }}>
            <span>{labelPrintDescription}</span>
          </div>
        )}
        {labelPrintDisplayPrice && (
          <div className={`flex gap-2 items-center`} style={{ fontSize: fSize[0] }}>
            <span className={`font-semibold`} style={{ fontSize: fSize[1] }}>
              {formatPrice(product.sellPrice)}
            </span>
            <span>{defCur.en_title}</span>
          </div>
        )}
        {labelPrintDisplayAddress &&
          product?.Product_Settings?.find((x: any) => x.key === "address")?.value && (
            <div style={{ fontSize: fSize[0] }}>
              <span>آدرس: </span>
              <span>{product?.Product_Settings?.find((x: any) => x.key === "address")?.value}</span>
            </div>
          )}
      </div>
    );
  }

  function Content({ product, settings }: { product?: Product; settings?: any }) {
    if (!product) return <div>hello</div>;
    settings = settings || defaultSettings;
    return (
      <div
        ref={contentRef}
        style={{
          width: settings?.width || "100%",
          display: "grid",
          gap: settings.spacing,
          padding: settings.padding,
          gridTemplateColumns: Array.from({ length: settings.countInRow }, () => "auto").join(" "),
          gridAutoRows: "min-content",
        }}
      >
        {!products?.length &&
          Array.from({ length: settings.count }, (_, index) => {
            return <Label key={index} {...{ product, settings }} />;
          })}

        {!!products?.length &&
          products.map((p, index) => {
            return <Label key={index} product={p} settings={settings} />;
          })}

        <ReactToPrint ref={ref} trigger={() => <></>} content={() => contentRef.current} />
      </div>
    );
  }
  const SettingsModal = useCallback(() => {
    const hasSettings = !!Object.keys(labelPrintSetting || labelSettings || {}).length;
    const [printSettings, setPrintSettings] = useState<LabelSettingsType>(hasSettings ? (labelPrintSetting ||labelSettings ) : defaultSettings);

    const saveSetting = async () => {
      const result = await axios.post("settings/labelprintsetting", {
        labelPrintSetting: printSettings
      }, { headers: { Authorization: `Bearer ${Token}` } }
      )
    }
    return (
      <Portal>
        <Modal open={state.open}>
          <ModalBox
            onClose={() => setState((x) => ({ ...x, open: false }))}
            title=""
            footer={
              <div className="flex items-center justify-end w-full">
                <BasicButton
                  variant="outlined"
                  color="disabled"
                  onClick={() => {
                    saveSetting()
                    dispatch(appSetLabelSettings(printSettings));
                    ref.current?.handleClick();
                  }}
                >
                  <span>
                    <img src={PrintImg} alt="" />
                  </span>
                  <span style={{ color: "#95A3B5", fontSize: "12px", fontWeight: 400 }}>چاپ لیبل</span>
                </BasicButton>
              </div>
            }
          >
            <div className="flex gap-8">
              <div className="flex justify-center w-full">
                <div
                  className="grid border rounded-md border-slate-200 max-h-[400px] max-w-[800px] overflow-auto"
                  style={{
                    gap: printSettings.spacing,
                    padding: printSettings.padding,
                    gridTemplateColumns: Array.from({ length: printSettings.countInRow }, () => "auto").join(
                      " "
                    ),
                    gridAutoRows: "min-content",
                    width: printSettings.width,
                  }}
                >
                  {!products?.length &&
                    Array.from({ length: printSettings.count }, (_, index) => {
                      return (
                        <div
                          key={index}
                          className="bg-gray-100 rounded-md"
                          style={{
                            width: printSettings.itemWidth,
                            height: printSettings.itemHeight,
                          }}
                        >
                          <Label product={state.item || {}} settings={printSettings} />
                        </div>
                      );
                    })}
                  {!!products?.length &&
                    products.map((product, index) => {
                      return (
                        <div
                          key={index}
                          className="bg-gray-100 rounded-md"
                          style={{
                            width: printSettings.itemWidth,
                            height: printSettings.itemHeight,
                          }}
                        >
                          <Label product={product} settings={printSettings} />
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className="min-w-[200px] max-w-[400px] flex justify-center flex-wrap self-start gap-4 aspect-square border rounded-md border-slate-200 p-2">
                {Object.keys(inputs).map((x, index) => {
                  let unit = "پیکسل";
                  let disabled = false;
                  if (["count", "countInRow"].includes(x)) {
                    unit = "عدد";
                  }
                  if (x === "count" && !!products?.length) disabled = true;
                  return (
                    <div key={index} className="w-35">
                      <BasicTextInput
                        disabled={disabled}
                        type="number"
                        label={(inputs as any)[x]}
                        style={{ paddingLeft: 0 }}
                        onChange={(val) => {
                          const newSettings = { ...printSettings, [x]: val };
                          setPrintSettings(newSettings);
                        }}
                        val={(printSettings as any)[x]}
                        prefix={
                          <div className="text-[10px] text-dark-3 border-r border-slate-300 px-2 min-w-[48px] flex items-center justify-center">
                            {unit}
                          </div>
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="hidden">
              <Content product={state.item} settings={printSettings} />
            </div>
          </ModalBox>
        </Modal>
      </Portal>
    );
  }, [state.open]);

  function openModal(item: any, products?: Partial<Product>[]) {
    setState((x) => ({ ...x, open: true, item }));
    if (products) setProducts(products);
  }

  return { Content, Label, SettingsModal, openModal, contentRef, ref };
}
